import React, {useEffect} from 'react';
import PeopleAltSharpIcon from "@material-ui/icons/PeopleAltSharp";
import DataTile from "../../metrics/DataTile";
import {useDispatch, useSelector} from "react-redux";
import testOKR from "./testOkr";
import BBIconJollyRogerSkull from "../../../../assets/bbCustomIcons/BBIconJollyRogerSkull";

const TileAdminExternalOKRBreachesTotal= ({props})=> {

    const {users, loadingUsers, loadingUsersError, } = useSelector(({users}) => users);
    const {okr, loadingAdminOKR, loadingAdminOKRError}= useSelector(({admin})=>admin);

    // const okr = testOKR;
    // const loadingAdminOKR = false;
    // const loadingAdminOKRError = false;
    // const loadingAdminOKRError = false;

    const valueFunction = ()=> {

        if(loadingAdminOKRError){
            return null
        } else {

            return okr
            && okr.breaches
            && okr.breaches.total
                ? okr.breaches.total.current
                : null;
        }

    }
    return(
        <DataTile
            color="electric-blue"
            subTitle="Recent Breaches"
            tipText={"OKR information is not available in the development server. Recent Breaches either credential or vulnerability."}
            icon={<BBIconJollyRogerSkull style={{fontSize: "70px"}}/>}
            // stateFetchAction={fetchUsers()}
            valueFunction={()=> valueFunction ? valueFunction() : null}
        />
    )
}

export default TileAdminExternalOKRBreachesTotal;